<template>
  <div>
    <v-app>
      <div class="dashboard-main-content" v-if="agency != null">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <form id="agencyDetailFrom">
                <div class="form-box">
                  <div class="form-content pb-2">
                    <div class="d-flex align-items-center justify-content-end p-3">
                      <h3 class="title"><br></h3>
                      <button
                          v-if="panelRights['PANEL_INVOICE_ACTIONS']"
                          @click="goToAgencyPaymentDetail"
                          class="theme-btn" style="margin-right: 10px !important;"
                          type="button">Cari Hesap Detayına Git</button>
                    </div>
                  </div>
                  <div class="form-content pb-2">
                  <div class="row justify-content-between">
                    <div class="col-lg-6">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <h3 class="title mb-3">Acente</h3>
                          <base-edit-input
                              v-model="agency.name"
                              :label="'Adı'"
                              :rules="'required'">
                          </base-edit-input>
                          <base-edit-input
                              v-model="agency.taxNumber"
                              :label="'Vergi Numarası'">
                          </base-edit-input>
                          <base-edit-input
                              v-if="projectName === 'miray'"
                              v-model="agency.currentCode"
                              :label="'Cari Kod'">
                          </base-edit-input>
                          <base-text-area-input
                              v-model="agency.address"
                              :label="'Adres'">
                          </base-text-area-input>
                          <div class="input-box d-flex align-items-center">
                            <label class="label-text">Web Servis Erişimi</label>
                            <input class="form-control " style="width: 5rem;" type="checkbox" v-model="agency.webServiceAccess">
                          </div>
                          <div class="input-box d-flex align-items-center">
                            <label class="label-text">Parçalı Ödeme İmkanı</label>
                            <input class="form-control" style="width: 5rem;" type="checkbox" v-model="agency.canTakePartialPayment">
                          </div>
                          <div class="input-box d-flex align-items-center">
                            <label class="label-text">Çoklu Oda seçimi</label>
                            <input class="form-control" style="width: 5rem;" type="checkbox" v-model="agency.canBookMultipleRooms">
                          </div>
                          <div v-if="projectName === 'selectum'" class="input-box d-flex align-items-center">
                            <label class="label-text">Kredi Kartı Ödeme İmkanı</label>
                            <input class="form-control" style="width: 5rem;" type="checkbox" v-model="agency.canTakeCreditCardPayment">
                          </div>
                          <base-select-input
                            v-model="agency.marketId"
                            :label="'Market'"
                            :rules="'required'"
                            :option-list="marketList">
                          </base-select-input>
                          <base-select-input v-if="projectName === 'miray'"
                              v-model="agency.agreementType"
                              :label="'Sözleşme Tipi'"
                              :rules="'required'"
                              :option-list="[{'id' : 'cash', 'name' : 'Nakit'}, {'id' : 'current', 'name' : 'Cari'}]">
                          </base-select-input>
                          <base-edit-input
                              v-if="agency.id == null && user != null"
                              v-model="user.email"
                              :label="'Email'"
                              :rules="'required|email'">
                          </base-edit-input>
                          <base-edit-input
                              v-if="agency.id == null && user != null"
                              v-model="user.password"
                              :rules="'required|password'"
                              :type="'password'"
                              :label="'Password'">
                          </base-edit-input>
                          <base-select-input
                              v-if="agency.id != null"
                              v-model="agency.masterUserId"
                              :textkey="['email']"
                              :label="'Admin'"
                              :option-list="userList"
                          ></base-select-input>
                          <base-text-area-input
                              v-model="agency.taxAddress"
                              :label="'Banka Bilgileri'">
                          </base-text-area-input>
                          <base-text-area-input
                              v-model="agency.accountantNotes"
                              :label="'Muhasebe Notları'">
                          </base-text-area-input>
                          <div class="btn-box mt-3">
                            <button v-if="agency.id == null" :class="{'disabled' : !formValid}" @click="create" class="theme-btn" type="button">Kaydet</button>
                            <button v-if="agency.id != null" :class="{'disabled' : !formValid}" @click="update" class="theme-btn" type="button">Güncelle</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6" v-if="agency.id != null">
                      <div class="card-item p-3" :style="!agency.active ? 'background-color: #F55454FF;' : ''">
                        <div class="contact-form-action">
                          <div class="input-box d-flex align-items-center flex">
                            <label v-if="agency.active" class="label-text">Aktif</label>
                            <label v-if="!agency.active" class="label-text" style="color: white">Aktif Değil</label>
                            <input class="form-control " style="width: 5rem;" type="checkbox" v-model="agency.active">
                          </div>
                        </div>
                      </div>
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <h3 class="title">Risk Limiti </h3>
                          <div class="form-box">
                            <div class="form-group">
                              <div class="container">
                                <base-edit-input
                                    v-model="agency.riskLimit"
                                    :rules="'required|min_value:1'"
                                    :type="'number'"
                                    :label="'Miktar'">
                                </base-edit-input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <agency-credit></agency-credit>
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <div class="form-box">
                            <div class="form-group">
                              <div class="container">
                                <base-select-input
                                    v-model="agency.commissionRateType"
                                    :optionList="[{name:'Sabit Oran',id:'fixed'},{name:'Dinamik Oran',id:'dynamic'}]"
                                    :rules="'required'"
                                    :type="'text'"
                                    :label="'Komisyon Tipi'"
                                ></base-select-input>
                                <base-edit-input
                                    v-model="agency.commissionRate"
                                    :rules="'required|min_value:0'"
                                    :type="'number'"
                                    :label="agency.commissionRateType === 'fixed'? 'Komisyon Oranı' : 'Standart Komisyon Oranı'">
                                </base-edit-input>
                                <div class="input-box d-flex align-items-center">
                                  <label class="label-text">Vergi Dahil Komisyon</label>
                                  <input class="form-control " style="margin-top:1px;margin-bottom:1px;width: 5rem;" type="checkbox" v-model="agency.commissionIncludeTaxes">
                                </div>
                              </div>
                              <v-data-table
                                  :headers="headers"
                                  :items="agencyCommissionRates"
                                  :items-per-page="5"
                                  v-if="agency.commissionRateType === 'dynamic'"
                                  class="elevation-1">
                                <template v-slot:top>
                                  <v-toolbar
                                      flat>
                                    <v-toolbar-title>Dinamik Komisyon Oranları</v-toolbar-title>
                                    <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                    ></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-dialog
                                        v-model="dialog"
                                        max-width="500px">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="primary"
                                            dark
                                            class="mb-2"
                                            v-bind="attrs"
                                            v-on="on">
                                          Yeni Oran Yarat
                                        </v-btn>
                                      </template>
                                      <v-card>
                                        <v-card-title>
                                          <span class="text-h5">Dinamik Komisyon Oranı</span>
                                        </v-card-title>

                                        <v-card-text>
                                          <v-container>
                                            <v-row>
                                              <v-col
                                                  cols="12"
                                                  sm="6"
                                                  md="6">
                                                <div class="input-box">
                                                  <label class="label-text">Başlangıç Tarihi</label>
                                                  <input class="form-control"
                                                         v-model="editedItem.startDate"
                                                         id="startDate"
                                                         type="date"
                                                         placeholder="">
                                                </div>
                                                <div class="input-box">
                                                  <label class="label-text">Komisyon Oranı</label>
                                                  <input class="form-control" v-model="editedItem.commissionRate" id="commissionRate" type="number" placeholder="">
                                                </div>
<!--                                                <v-text-field-->
<!--                                                    v-model="editedItem.commissionRate"-->
<!--                                                    label="Komisyon Oranı"-->
<!--                                                ></v-text-field>-->
                                                <!--                                            <v-text-field-->
                                                <!--                                                v-model="editedItem.name"-->
                                                <!--                                                label="Market Adı"-->
                                                <!--                                            ></v-text-field>-->
                                              </v-col>
                                              <v-col
                                                  cols="12"
                                                  sm="6"
                                                  md="6">
                                                <div class="input-box">
                                                  <label class="label-text">Bitiş Tarihi</label>
                                                  <input class="form-control"
                                                         v-model="editedItem.endDate"
                                                         id="endDate"
                                                         type="date"
                                                         placeholder="">
                                                </div>
                                              </v-col>
                                            </v-row>
                                          </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                          <v-spacer></v-spacer>
                                          <v-btn
                                              color="blue darken-1"
                                              text
                                              @click="close">
                                            Cancel
                                          </v-btn>
                                          <v-btn
                                              color="blue darken-1"
                                              text
                                              @click="save">
                                            Save
                                          </v-btn>
                                        </v-card-actions>
                                      </v-card>
                                    </v-dialog>
                                  </v-toolbar>
                                </template>
                                <template v-slot:item.commissionRate="{ item }">
                                  <tr>
                                    {{item.commissionRate}}
                                  </tr>
                                </template>
                                <template v-slot:item.startDate="{ item }">
                                  <tr>
                                    {{item.startDate | ddMMyyyy}}
                                  </tr>
                                </template>
                                <template v-slot:item.endDate="{ item }">
                                  <tr>
                                    {{item.endDate | ddMMyyyy}}
                                  </tr>
                                </template>
                                <template v-slot:item.actions="{ item }">
                                  <!--                              <v-icon-->
                                  <!--                                  small-->
                                  <!--                                  class="mr-2"-->
                                  <!--                                  @click="editItem(item)"-->
                                  <!--                              >-->
                                  <!--                                mdi-pencil-->
                                  <!--                              </v-icon>-->
                                  <v-icon
                                      small
                                      @click="deleteItem(item)"
                                  >
                                    mdi-delete
                                  </v-icon>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            Rezervasyonlar
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div class="row" v-if="agency.id != null">
                              <div class="col-lg-12">
                                <agency-booking-list :booking-list="bookingList"></agency-booking-list>
                              </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>

                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            Hareketler
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div class="row" v-if="agency.id != null">
                              <div class="col-lg-12">
                                <agency-transaction-list></agency-transaction-list>
                              </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>

                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            Ödemeler
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div class="row" v-if="agency.id != null">
                              <div class="col-lg-12">
                                <agency-payments-list/>
                              </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>

                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            Çalışanlar
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div class="row" v-if="agency.id != null">
                              <div class="col-lg-12">
                                <agency-user-list></agency-user-list>
                              </div>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div>
        <agency-user-detail ref="agencyUser"></agency-user-detail>
      </div>
    </v-app>
  </div>
</template>

<script>

import AgencyBookingList from "./AgencyBookingList";
import AgencyTransactionList from "./AgencyTransactionList";
import AgencyCredit from "./agencyCredit";
import AgencyUserList from "./AgencyUserList";
import AgencyUserDetail from "./AgencyUserDetail";
import BaseEditInput from "../base/BaseEditInput";
import validationFormUtils from "../../util/validationFormUtils";
import BaseSelectInput from "../base/BaseSelectInput";
import messagePopupManager from "../../util/messagePopupManager";
import AgencyPaymentsList from "./AgencyPaymentsList";
import BaseTextAreaInput from "../base/BaseTextAreaInput";
export default {
  name: "AgencyDetail",
  components: {
    BaseTextAreaInput,
    AgencyPaymentsList,
    BaseSelectInput,
    BaseEditInput, AgencyUserDetail, AgencyUserList, AgencyCredit, AgencyTransactionList, AgencyBookingList
  },
  data:function (){
    return{
      formValid:false,
      dialog: false,
      dialogDelete: false,
      editedItem: {
        name: '',
      },
      defaultItem: {
        name: '',
      },
      headers: [
        {
          text: 'Başlangıç Tarihi',
          align: 'start',
          sortable: true,
          value: 'startDate',
        },
        {
          text: 'Bitiş Tarihi',
          value: 'endDate',
        },
        {
          text: 'Komisyon Oranı',
          value: 'commissionRate',
        },
        {
          text: 'actions',
          value: 'actions',
        }
      ]
    }
  },
  props : {
    bookingList: null,
  },
  computed:{
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    },
    agency:{
      get(){
        return this.$store.getters.getAgency;
      },
    },
    agencyCommissionRates:{
      get(){
        return this.$store.getters.getAgencyCommissionRates;
      },
    },
    user:{
      get(){
        return this.$store.getters.getAgencyUser;
      },
    },
    userList:{
      get(){
        return this.$store.getters.getAgencyUserList;
      },
    },
    marketList:{
      get(){
        return this.$store.getters.getMarketList;
      }
    },
    projectName:{
      get() {
        return this.$store.getters.getProjectName;
      }
    }
  },
  methods:{
    goToAgencyPaymentDetail(){
      this.$router.push('/agency/payment-details/' + this.agency.id);
    },
    deleteItem (item) {
      this.editedItem = Object.assign({}, item)
      messagePopupManager.showDeleteQuestion(() => {
        this.$store.dispatch("deleteAgencyCommissionRate",this.editedItem.id)
            .then(()=>{
              this.$store.dispatch("loadAgencyCommissionRateList", this.$route.params.id);
            })
            .catch(error => {
              messagePopupManager.showError();
            })
      })
    },
    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    save () {
      if(!this.editedItem.startDate && !this.editedItem.endDate && !this.editedItem.commissionRate){
        messagePopupManager.showError("Tüm alanları doldurmanız gerekmektedir.");
        return;
      }

      if (this.editedIndex > -1) {
      } else {
        this.editedItem.agencyId = this.$route.params.id;

        this.$store.dispatch("createAgencyCommissionRate", this.editedItem)
            .then(()=>{
              this.$store.dispatch("loadAgencyCommissionRateList", this.$route.params.id);
            })
            .catch(error => {
              messagePopupManager.showError();
            })
      }
      this.close()
    },
    create(){
      if(this.formValid){
          this.$store.dispatch("createAgency",this.agency).then(response => {
            messagePopupManager.showSuccess();
          }).catch(error => {
            messagePopupManager.showError("Hata", error.response.data.message);
          });
      }
    },
    update(){
      this.$store.dispatch("updateAgency", this.agency).then(response => {
        messagePopupManager.showSuccess();
      }).catch(error => {
        messagePopupManager.showError("Hata", error.response.data.message);
      });
    },
    checkValid(){
      validationFormUtils.checkFormFields(this);
    }
  },
  watch:{
    agency:{
      deep:true,
      handler:function (){
        this.checkValid();
      }
    },
    user:{
      deep:true,
      handler:function (){
        this.checkValid();
      }
    }
  }
}
</script>

<style scoped>

.v-expansion-panel-header{
  background-color: #1976d2;
  color: white;
}

.v-expansion-panel{
  padding-bottom: 5px;
}
.v-expansion-panel-content{
  padding-top: 15px;
}

</style>